import * as React from 'react';
import { TOAST_LIMIT } from './constants';
import { ToasterState, ToasterAction } from './types';

function reducer(state: ToasterState, action: ToasterAction): ToasterState {
  switch (action.type) {
    case 'ADD_TOAST': {
      return {
        ...state,
        toasts: [action.toast, ...state.toasts].slice(0, TOAST_LIMIT),
      };
    }
    case 'REMOVE_TOAST': {
      if (action.id === undefined) {
        return {
          ...state,
          toasts: [],
        };
      }
      return {
        ...state,
        toasts: state.toasts.filter(toast => toast.id !== action.id),
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}

const listeners: Array<(state: ToasterState) => void> = [];
let memoryState: ToasterState = { toasts: [] };

export function dispatch(action: ToasterAction): void {
  memoryState = reducer(memoryState, action);
  listeners.forEach(listener => {
    listener(memoryState);
  });
}

export function useToaster(): ToasterState {
  const [state, setState] = React.useState<ToasterState>(memoryState);

  React.useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);

  return {
    ...state,
  };
}
